import React from 'react';
import {
  clickCancel,
  submitFormCreate,
  submitFormUpdate,
  showCloneOutletProgress,
} from 'actions/outletPages/list';
import { askConfirmAction } from 'actions/confirm-action';
import { isDirty } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { push } from 'react-router-redux';
import * as clevertapOutletsList from 'clevertap/outlets/list';
import moment from 'moment';
import OutletForm from './OutletForm';
import styles from './OutletDetail.css';

class OutletDetail extends React.Component {
  componentDidMount() {
    browserHistory.listenBefore(location => {
      if (
        this.props.isDirtyForm &&
        !this.props.nextAction &&
        this.props.cloneResult &&
        !this.props.cloneResult.success
      ) {
        // negate the change location, instead use sagas to handle the change location
        this.props.dispatch(askConfirmAction(push(location.pathname)));
        return false;
      }
    });
  }

  render() {
    const { outlet } = this.props;
    let association = null;

    if (outlet) {
      const { saudagar, moka } = outlet;
      if (saudagar) {
        association = {
          moka: {
            id: outlet.id,
            name: moka.name,
            address: moka.full_address || '',
          },
          saudagar: {
            id: saudagar.id,
            name: saudagar.merchant_name,
            address: outlet.full_address || '',
          },
        };
      }
    }

    return (
      <div className={styles.wrapper}>
        <div className={styles.form}>
          <OutletForm
            association={association}
            onSubmit={this._onSubmit}
            onClickCancel={this._onClickCancel}
          />
        </div>
      </div>
    );
  }

  _onClickCancel = () => {
    this.props.dispatch(clickCancel());
    this.props.isDirtyForm = false;
  };

  _onSubmit = values => {
    const {
      outlets,
      paymentMethodList,
      isSubscribed,
      loggedInEmail,
      cloneOutletDropdown,
    } = this.props;
    const data = {};

    data.name = values.name.trim();
    data.address = values.address.trim();
    data.phone_number = `0${values.phone.trim()}`;
    data.city = values.city.trim();
    data.province = values.province.trim();
    data.kecamatan = values.kecamatan.trim();
    data.postal_code = values.postal.trim();
    data.business_id = values.businessId;
    if (values.outletToggle) {
      data.isCloneOutlet = values.outletToggle;
      data.source_clone_id = values.clonedOutlet;
      data.cutoff_date = moment().toISOString();

      const sourceOutlet = cloneOutletDropdown.outlets.find(
        outlet => Number(outlet.id) === Number(values.clonedOutlet)
      );
      data.source_clone_name = sourceOutlet ? trunc(sourceOutlet.name) : '';
      data.destination_outlet_name = trunc(values.name.trim());
    }

    if (values.id) {
      this.props.dispatch(
        submitFormUpdate(values.id, { outlet: data }, {}, outlets)
      );
      clevertapOutletsList.editOutletSuccess({
        outlet: data,
        outletId: values.id,
        loggedInEmail,
      });
    } else {
      if (data.isCloneOutlet) {
        this.props.dispatch(showCloneOutletProgress(data));
      }
      this.props.dispatch(
        submitFormCreate(
          { outlet: data },
          {},
          outlets,
          paymentMethodList,
          isSubscribed
        )
      );
    }
  };
}

OutletDetail.propTypes = {
  outlet: PropTypes.object,
  dispatch: PropTypes.func,
  outlets: PropTypes.array,
  isDirtyForm: PropTypes.bool,
  nextAction: PropTypes.object,
  loggedInEmail: PropTypes.string,
};

function trunc(name) {
  return name.length > 25 ? `${name.substring(0, 25)}...` : name;
}

function mapStateToProps(state) {
  const {
    paymentMethodList,
    outletDetail,
    cloneOutletDropdown,
    cloneResult,
  } = state.outletPages.list;
  return {
    isSubscribed: state.moka.user.already_subscribed,
    isDirtyForm: isDirty('outlet')(state),
    nextAction: state.confirmAction.nextAction,
    paymentMethodList,
    outletDetail,
    cloneResult,
    cloneOutletDropdown,
  };
}

export default connect(mapStateToProps)(OutletDetail);
